import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { AdminFeaturesService } from '../service/admin-features.service';

@Component({
  selector: 'app-playzone-admin',
  templateUrl: './playzone-admin.component.html',
  providers: [MessageService],
})
export class PlayzoneAdminComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  quizzes: any[] = [];
  loading = false;

  // quiz modal
  quizModal = false;
  editingQuiz: any = null;
  qform: any = this.blankQuiz();

  // selected quiz + questions
  selected: any = null;
  questions: any[] = [];

  // question modal
  qModal = false;
  editingQuestion: any = null;
  question: any = this.blankQuestion();

  constructor(private svc: AdminFeaturesService, private toast: MessageService) {}

  ngOnInit() { this.load(); }

  blankQuiz()     { return { title: '', description: '', imageUrl: '', coinPool: 500, timePerQuestionSec: 30, maxAttempts: 2, orderIndex: 0, isActive: true }; }
  blankQuestion() { return { topic: '', questionText: '', options: ['', '', '', ''], correctIndex: 0, orderIndex: 0 }; }

  load() {
    this.loading = true;
    this.svc.listQuizzes().pipe(takeUntil(this.destroy$)).subscribe((r: any[]) => {
      this.quizzes = r || []; this.loading = false;
    }, () => { this.loading = false; this.err('Failed to load quizzes'); });
  }

  // ── Quiz CRUD ────────────────────────────────────────────────────────────────
  newQuiz()  { this.editingQuiz = null; this.qform = this.blankQuiz(); this.quizModal = true; }
  editQuiz(q: any) {
    this.editingQuiz = q;
    this.qform = { title: q.title, description: q.description || '', imageUrl: q.imageUrl || '', coinPool: q.coinPool,
                   timePerQuestionSec: q.timePerQuestionSec, maxAttempts: q.maxAttempts, orderIndex: q.orderIndex, isActive: q.isActive };
    this.quizModal = true;
  }
  closeQuiz() { this.quizModal = false; }

  saveQuiz() {
    if (!this.qform.title) { this.err('Title is required'); return; }
    const b = {
      title: this.qform.title, description: this.qform.description || null, imageUrl: this.qform.imageUrl || null,
      coinPool: Number(this.qform.coinPool) || 0, timePerQuestionSec: Number(this.qform.timePerQuestionSec) || 30,
      maxAttempts: Number(this.qform.maxAttempts) || 1, orderIndex: Number(this.qform.orderIndex) || 0, isActive: !!this.qform.isActive,
    };
    const req = this.editingQuiz ? this.svc.updateQuiz(this.editingQuiz.id, b) : this.svc.saveQuiz(b);
    req.pipe(takeUntil(this.destroy$)).subscribe(() => { this.ok(this.editingQuiz ? 'Quiz saved' : 'Quiz created'); this.closeQuiz(); this.load(); }, () => this.err('Save failed'));
  }

  deleteQuiz(q: any) {
    if (!confirm(`Delete quiz "${q.title}"? Questions are removed too.`)) return;
    this.svc.deleteQuiz(q.id).pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.ok('Quiz deleted');
      if (this.selected && this.selected.id === q.id) this.selected = null;
      this.load();
    }, (e: any) => this.err(e && e.error && e.error.error ? e.error.error : 'Delete failed'));
  }

  // ── Questions ────────────────────────────────────────────────────────────────
  openQuestions(q: any) {
    this.selected = q;
    this.svc.getQuiz(q.id).pipe(takeUntil(this.destroy$)).subscribe((full: any) => {
      this.questions = (full && full.questions) || [];
    }, () => this.err('Failed to load questions'));
  }
  backToList() { this.selected = null; this.questions = []; }

  newQuestion() { this.editingQuestion = null; this.question = this.blankQuestion(); this.qModal = true; }
  editQuestion(q: any) {
    this.editingQuestion = q;
    const opts = (q.options || []).slice(); while (opts.length < 4) opts.push('');
    this.question = { topic: q.topic || '', questionText: q.questionText, options: opts, correctIndex: q.correctIndex, orderIndex: q.orderIndex };
    this.qModal = true;
  }
  closeQuestion() { this.qModal = false; }
  addOption()    { if (this.question.options.length < 4) this.question.options.push(''); }
  removeOption(i: number) {
    if (this.question.options.length <= 2) return;
    this.question.options.splice(i, 1);
    if (this.question.correctIndex >= this.question.options.length) this.question.correctIndex = 0;
  }

  saveQuestion() {
    const opts = this.question.options.map((o: string) => (o || '').trim()).filter((o: string) => o);
    if (!this.question.questionText) { this.err('Question text is required'); return; }
    if (opts.length < 2) { this.err('At least 2 options required'); return; }
    if (this.question.correctIndex >= opts.length) { this.err('Pick a valid correct answer'); return; }
    const b = { topic: this.question.topic || null, questionText: this.question.questionText, options: opts,
                correctIndex: Number(this.question.correctIndex), orderIndex: Number(this.question.orderIndex) || 0 };
    const req = this.editingQuestion ? this.svc.updateQuestion(this.editingQuestion.id, b) : this.svc.addQuestion(this.selected.id, b);
    req.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.ok(this.editingQuestion ? 'Question saved' : 'Question added'); this.closeQuestion(); this.openQuestions(this.selected); this.load();
    }, () => this.err('Save failed'));
  }

  deleteQuestion(q: any) {
    if (!confirm('Delete this question?')) return;
    this.svc.deleteQuestion(q.id).pipe(takeUntil(this.destroy$)).subscribe(() => { this.ok('Deleted'); this.openQuestions(this.selected); this.load(); }, () => this.err('Delete failed'));
  }

  private ok(m: string)  { this.toast.add({ severity: 'success', summary: m }); }
  private err(m: string) { this.toast.add({ severity: 'error', summary: m }); }

  ngOnDestroy() { this.destroy$.next(); this.destroy$.complete(); }
}
